const COBRA_STRATEGY_IDS = new Set(['q_cobra', 'q_cobra_v2', 'q_cobra_v3', 'q_cobra_v4']);
const CHANAKYA_STRATEGY_IDS = new Set(['chanakya', 'chanakya_inverse']);

const STRATEGY_LABELS = {
    q_cobra: 'Q Cobra',
    q_cobra_v2: 'Q Cobra V2',
    q_cobra_v3: 'qCobra.V3',
    q_cobra_v4: 'qCobra.V4',
    chanakya: 'Chanakya',
    chanakya_inverse: 'Chanakya Inverse',
    vyasa_v1: 'Vyasa',
    vyasa: 'Vyasa',
    garuda: 'Garuda',
};

export function resolveStrategyFamily(strategyId) {
    if (COBRA_STRATEGY_IDS.has(strategyId)) {
        return 'cobra';
    }
    if (strategyId === 'chanakya') {
        return 'chanakya';
    }
    if (strategyId === 'chanakya_inverse') {
        return 'chanakya_inverse';
    }
    if (strategyId === 'vyasa_v1' || strategyId === 'vyasa') {
        return 'vyasa';
    }
    if (typeof strategyId === 'string' && strategyId.startsWith('garuda')) {
        return 'garuda';
    }
    return 'cobra';
}

export function resolveStrategyMeta(strategyId) {
    const family = resolveStrategyFamily(strategyId);
    return {
        strategyId,
        family,
        variant: strategyId,
        label: STRATEGY_LABELS[strategyId] || strategyId,
    };
}

export function findAccountForClient(state, clientId) {
    const accounts = Array.isArray(state?.accounts) ? state.accounts : [];
    if (!accounts.length) {
        return null;
    }
    if (!clientId) {
        return accounts[0];
    }
    return accounts.find((account) => account.accountId === clientId) || accounts[0];
}

export function findStrategyForAccount(account, strategyId) {
    const strategies = Array.isArray(account?.strategies) ? account.strategies : [];
    if (!strategies.length) {
        return null;
    }
    if (!strategyId) {
        return strategies[0];
    }
    return strategies.find((strategy) => {
        const candidateId = strategy.strategyId || strategy.summary?.strategyId || '';
        const baseId = candidateId.split(':')[0];
        return candidateId === strategyId || baseId === strategyId;
    }) || strategies[0];
}

export function resolveInstanceContext(state, strategyId, clientId) {
    const account = findAccountForClient(state, clientId);
    const strategy = findStrategyForAccount(account, strategyId);
    const summary = strategy?.summary || state?.summary || {};
    const latestLayer = strategy?.layers?.[0] || state?.layers?.[0] || null;
    const latestActivity = state?.activity?.find(
        (entry) => entry.accountId === account?.accountId
    ) || state?.activity?.[0] || null;
    const events = strategy?.events || state?.events || [];
    const legs = latestLayer?.legs || latestActivity?.legs || strategy?.legs || [];
    const positions = latestActivity?.positions || strategy?.positions || [];
    const orders = latestActivity?.orders || strategy?.orders || [];
    const stops = latestActivity?.stops || strategy?.stops || [];
    const tradeHistory = state?.tradeHistory?.length
        ? state.tradeHistory
        : strategy?.tradeHistory || [];

    return {
        account,
        strategy,
        summary,
        latestLayer,
        latestActivity,
        events,
        legs,
        positions,
        orders,
        stops,
        tradeHistory,
    };
}

export { CHANAKYA_STRATEGY_IDS, COBRA_STRATEGY_IDS };
